import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'button-search',
	templateUrl: './button-search.component.html',
	styleUrls: ['./button-search.component.scss'],
})
export class ButtonSearchComponent implements OnInit {
	@Output() eventClick = new EventEmitter<any>();

	constructor() 
	{
		// This is intentional
	}

	ngOnInit(): void 
	{
		// This is intentional
	}

	search() {
		this.eventClick.emit();
	}
}
